import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  key: 2,
  class: "optDisabledText"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 4,
  class: "optDisabledText"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "cursor": "pointer",
    "margin-left": "10px",
    "color": "#F4333C"
  }
}, "删除", -1);
const _hoisted_6 = {
  key: 6,
  class: "optDisabledText"
};
const _hoisted_7 = {
  class: "paginationNumber"
};
const _hoisted_8 = {
  class: "paginationNumber"
};
const _hoisted_9 = {
  class: "paginationNumber"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DynaQueryForm = _resolveComponent("DynaQueryForm");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  const _component_el_row = _resolveComponent("el-row");
  const _component_DialogView = _resolveComponent("DialogView");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock(_Fragment, null, [$data.tableParams.queryForm ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle({
      width: '100%',
      height: $data.queryFormHeight
    }),
    ref: "queryFormContainer"
  }, [(_openBlock(), _createBlock(_component_DynaQueryForm, {
    "form-id": $data.tableParams.queryForm,
    "init-query": $props.initQuery,
    onAddMore: $options.addMore,
    key: $data.queryFormVersion,
    title: $data.tableData.title,
    onOnQuery: $options.onQuery,
    onOnReset: $options.onResetQuery
  }, null, 8, ["form-id", "init-query", "onAddMore", "title", "onOnQuery", "onOnReset"]))], 4)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "beforeTable"), _createVNode(_component_el_row, {
    style: {
      "width": "100%"
    },
    class: "flex flex-col mt8"
  }, {
    default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
      style: {
        "width": "100%",
        "box-shadow": "#EEEEEE -2px 2px 2px"
      },
      data: $data.tableData.list,
      sortable: 'custom',
      "highlight-current-row": $props.highlightCurrentRow,
      onCurrentChange: _cache[0] || (_cache[0] = row => _ctx.$emit('onRowSelectChange', row)),
      onSortChange: $options.onSortChange,
      ref: "icetable",
      border: "",
      "header-row-style": {
        color: 'black'
      },
      "header-cell-style": {
        background: '#FAFAFA'
      }
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tableData.header, (h, i) => {
        return _openBlock(), _createBlock(_component_el_table_column, {
          resizable: "",
          key: h.name,
          sortable: !!h.sortable,
          prop: h.name,
          label: h.label,
          type: h.colType,
          index: $options.indexValueMethod,
          fixed: h.name == 'operates' ? 'right' : h.fixed,
          "show--tooltip": i + 1 < $data.tableData.header.length /** 最后一栏不省略 */,
          width: h.width
        }, _createSlots({
          _: 2
        }, [h.hasSlot ? {
          name: "default",
          fn: _withCtx(scope => [h.name != 'operates' ? _renderSlot(_ctx.$slots, h.name, {
            key: 0,
            data: scope.row,
            rowData: scope.row[h.name],
            mapping: $data.tableData.textMapping ? $data.tableData.textMapping[h.name] : null,
            rowId: scope.row['id']
          }) : _createCommentVNode("", true), h.name == 'operates' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [scope.row[h.name]['handle'] != null ? _renderSlot(_ctx.$slots, "operates-handle", {
            key: 0,
            data: scope.row,
            mapping: $data.tableData.textMapping,
            rowId: scope.row['id']
          }) : _createCommentVNode("", true), scope.row[h.name]['detail'] ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            onClick: $event => $options.onDetailData(scope.row),
            style: {
              "cursor": "pointer",
              "margin-left": "10px",
              "color": "#1388ff"
            }
          }, "详情", 8, _hoisted_1)) : scope.row[h.name]['detail'] != null ? (_openBlock(), _createElementBlock("span", _hoisted_2, "详情")) : _createCommentVNode("", true), scope.row[h.name]['edit'] ? (_openBlock(), _createElementBlock("span", {
            key: 3,
            onClick: $event => $options.onEditData(scope.row),
            style: {
              "cursor": "pointer",
              "margin-left": "10px",
              "color": "#F6B700"
            }
          }, "编辑", 8, _hoisted_3)) : scope.row[h.name]['edit'] != null ? (_openBlock(), _createElementBlock("span", _hoisted_4, "编辑")) : _createCommentVNode("", true), scope.row[h.name]['delete'] ? (_openBlock(), _createBlock(_component_el_popconfirm, {
            key: 5,
            title: "确定删除吗",
            onConfirm: $event => $options.onDeleteData(scope.row)
          }, {
            reference: _withCtx(() => [_hoisted_5]),
            _: 2
          }, 1032, ["onConfirm"])) : scope.row[h.name]['delete'] != null ? (_openBlock(), _createElementBlock("span", _hoisted_6, "删除")) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]),
          key: "0"
        } : undefined]), 1032, ["sortable", "prop", "label", "type", "index", "fixed", "show--tooltip", "width"]);
      }), 128))]),
      _: 3
    }, 8, ["data", "highlight-current-row", "onSortChange"])), [[_directive_loading, $data.tableDataLoading]]), _createVNode(_component_el_config_provider, {
      locale: $setup.locale
    }, {
      default: _withCtx(() => [_createVNode(_component_el_pagination, {
        class: "mt8",
        background: "",
        "current-page": $data.page,
        "page-size": $data.pageSize,
        "pager-count": $props.maxPageCnt,
        "page-sizes": $props.pageSizeChoices,
        onSizeChange: $options.onSizeChange,
        onCurrentChange: $options.gotoPage,
        layout: "sizes,slot,->,prev, pager, next,jumper",
        total: $data.total
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, [_createTextVNode(" 当前第"), _createElementVNode("span", _hoisted_7, _toDisplayString(($data.page - 1) * $data.pageSize + $data.tableData.list.length), 1), _createTextVNode("/"), _createElementVNode("span", _hoisted_8, _toDisplayString($data.total), 1), _createTextVNode("项，共"), _createElementVNode("span", _hoisted_9, _toDisplayString(parseInt($data.total / $data.pageSize) + 1), 1), _createTextVNode("页")])]),
        _: 1
      }, 8, ["current-page", "page-size", "pager-count", "page-sizes", "onSizeChange", "onCurrentChange", "total"])]),
      _: 1
    }, 8, ["locale"])]),
    _: 3
  }), _createVNode(_component_DialogView, {
    "visible-control": $data.createDialogVisible,
    "data-id": $data.tableParams.createDialog,
    onSubmit: $options.createData,
    onOnDialogClose: _cache[1] || (_cache[1] = $event => {
      $data.createDialogVisible = false;
    })
  }, null, 8, ["visible-control", "data-id", "onSubmit"]), _createVNode(_component_DialogView, {
    "visible-control": $data.editDialogVisible,
    "data-id": $data.tableParams.updateDialog,
    "bind-id": $data.editBindId,
    onSubmit: $options.updateData,
    onOnDialogClose: _cache[2] || (_cache[2] = $event => {
      $data.editDialogVisible = false;
    })
  }, null, 8, ["visible-control", "data-id", "bind-id", "onSubmit"]), _createVNode(_component_DialogView, {
    "visible-control": $data.detailDialogVisible,
    "data-id": $data.tableParams.detailDialog,
    "bind-id": $data.detailBindId,
    onOnDialogClose: _cache[3] || (_cache[3] = $event => {
      $data.detailDialogVisible = false;
    })
  }, null, 8, ["visible-control", "data-id", "bind-id"])], 64);
}